import styled from 'styled-components';
import H1 from '../text/H1';
var USPTitle = styled(H1).withConfig({
  displayName: "Title__USPTitle",
  componentId: "sc-1cngdi3-0"
})(["text-align:left;color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.color || null;
});
export default USPTitle;